<template>
    <b-row>
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <b-card class="sa-card sa-card-border" header="Scala del dolore" header-tag="header" footer-tag="footer">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data"> Scala di valutazione NRS:</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDolore.scalaValutazione }}</span>
                        <b-form-select v-else class="mb-2 mr-sm-2 mb-sm-0" :options="valutazioneNrsOptions" value-field="value" text-field="text" v-model="jsonDataValutazioneDolore.scalaValutazione"> </b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Scala di valutazione verbale</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDolore.scalaValutazioneVerbale }}</span>
                        <b-form-select v-else :options="valutazioneVerbaleOptions" class="mb-2 mr-sm-2 mb-sm-0" value-field="value" text-field="text" v-model="jsonDataValutazioneDolore.scalaValutazioneVerbale"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Sede</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDolore.sede }}</span>
                        <b-form-input v-else class="mb-2 mr-sm-2 mb-sm-0" v-model="jsonDataValutazioneDolore.sede"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Irradiazione</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDolore.irradiazione }}</span>
                        <b-form-input v-else class="mb-2 mr-sm-2 mb-sm-0" v-model="jsonDataValutazioneDolore.irradiazione"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Modalità di insorgenza</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDolore.modalitaInsorgenza }}</span>
                        <b-form-input v-else class="mb-2 mr-sm-2 mb-sm-0" v-model="jsonDataValutazioneDolore.modalitaInsorgenza"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Andamento/modificazioni nel tempo</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDolore.andamentoModificazioneTempo }}</span>
                        <b-form-input v-else class="mb-2 mr-sm-2 mb-sm-0" v-model="jsonDataValutazioneDolore.andamentoModificazioneTempo"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Continuo</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDolore.andamentoModificazioneTempoContinuo }}</span>
                        <b-form-select v-else :options="siNoOptions" class="mb-2 mr-sm-2 mb-sm-0" value-field="value" text-field="text" v-model="jsonDataValutazioneDolore.andamentoModificazioneTempoContinuo"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Intermittente</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDolore.andamentoModificazioneTempoIntermittente }}</span>
                        <b-form-select v-else :options="siNoOptions" class="mb-2 mr-sm-2 mb-sm-0" value-field="value" text-field="text" v-model="jsonDataValutazioneDolore.andamentoModificazioneTempoIntermittente"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Cosa lo aggrava</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDolore.cosaAggrava }}</span>
                        <b-form-input v-else class="mb-2 mr-sm-2 mb-sm-0" v-model="jsonDataValutazioneDolore.cosaAggrava"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Cosa lo allevia</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDolore.cosaAllevia }}</span>
                        <b-form-input v-else class="mb-2 mr-sm-2 mb-sm-0" v-model="jsonDataValutazioneDolore.cosaAllevia"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Accessualità</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDolore.accessualita }}</span>
                        <b-form-input v-else class="mb-2 mr-sm-2 mb-sm-0" v-model="jsonDataValutazioneDolore.accessualita"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Cronologia: quando è insorto</label>
                        <span v-if="isReadOnly">{{ formatDate(jsonDataValutazioneDolore.dataOraInsorto) }}</span>
                        <date-picker v-else format="DD-MM-YYYY" value-type="timestamp" v-model="jsonDataValutazioneDolore.dataOraInsorto" type="date"></date-picker>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Somatico</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDolore.doloreSomatico }}</span>
                        <b-form-select v-else :options="siNoOptions" class="mb-2 mr-sm-2 mb-sm-0" value-field="value" text-field="text" v-model="jsonDataValutazioneDolore.doloreSomatico"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Viscerale</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDolore.doloreViscerale }}</span>
                        <b-form-select v-else :options="siNoOptions" class="mb-2 mr-sm-2 mb-sm-0" value-field="value" text-field="text" v-model="jsonDataValutazioneDolore.doloreViscerale"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Neuropatico</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDolore.doloreNeuropatico }}</span>
                        <b-form-select v-else :options="siNoOptions" class="mb-2 mr-sm-2 mb-sm-0" value-field="value" text-field="text" v-model="jsonDataValutazioneDolore.doloreNeuropatico"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Altro</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDolore.doloreAltro }}</span>
                        <b-form-select v-else :options="siNoOptions" class="mb-2 mr-sm-2 mb-sm-0" value-field="value" text-field="text" v-model="jsonDataValutazioneDolore.doloreAltro"></b-form-select>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Farmaci in atto</label>
                        <span v-if="isReadOnly">{{ jsonDataValutazioneDolore.farmaciAtto }}</span>
                        <b-form-textarea v-else rows="3" v-model="jsonDataValutazioneDolore.farmaciAtto"></b-form-textarea>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import DatePicker from "vue2-datepicker";
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    components: { DatePicker },
    mixins: [UtilityMixin],
    props: {
        idRisorsa: {
            type: String,
            default: function () {
                return null;
            },
        },
        idAccettazione: {
            type: String,
            default: function () {
                return null;
            },
        },
        isReadOnly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            jsonDataValutazioneDolore: {
                idAccettazione: this.idAccettazione,
                scalaValutazione: null,
                scalaValutazioneVerbale: null,
                sede: null,
                irradiazione: null,
                andamentoModificazioneTempo: null,
                andamentoModificazioneTempoContinuo: null,
                andamentoModificazioneTempoIntermittente: null,
                cosaAggrava: null,
                cosaAllevia: null,
                accessualita: null,
                dataOraInsorto: new Date().getTime(),
                doloreSomatico: null,
                doloreViscerale: null,
                doloreNeuropatico: null,
                doloreAltro: null,
                farmaciAtto: null,
                modalitaInsorgenza: null,
            },
            pathResource: "/rsascalevalutazionepazientedolore",

            valutazioneNrsOptions: [
                { value: null, text: "-Seleziona valore-" },
                { value: "0", text: "0" },
                { value: "1", text: "1" },
                { value: "2", text: "2" },
                { value: "3", text: "3" },
                { value: "4", text: "4" },
                { value: "5", text: "5" },
                { value: "6", text: "6" },
                { value: "7", text: "7" },
                { value: "8", text: "8" },
                { value: "9", text: "9" },
                { value: "10", text: "10" },
            ],
            valutazioneVerbaleOptions: [
                { value: null, text: "-Seleziona valore-" },
                { value: "NESSUN DOLORE", text: "NESSUN DOLORE" },
                { value: "DOLORE LEGGERO", text: "DOLORE LEGGERO" },
                { value: "DOLORE MODERATO", text: "DOLORE MODERATO" },
                { value: "DOLORE INTENSO", text: "DOLORE INTENSO" },
            ],
            siNoOptions: [
                { value: null, text: "-Seleziona valore-" },
                { value: "SI", text: "SI" },
                { value: "NO", text: "NO" },
            ],
        };
    },
    mounted() {
        let me = this;
        let routeIdAccettazione = me.$route?.query?.idAccettazione ? me.$route.query.idAccettazione : me.$route?.params?.id;
        me.idAccettazione = me.idAccettazione ? me.idAccettazione : routeIdAccettazione;
        if (me.idRisorsa) {
            me.visualizzaScalaValutazioneDolore();
        }
    },
    watch: {
        jsonDataValutazioneDolore: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    methods: {
        visualizzaScalaValutazioneDolore() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResource + "/" + me.idRisorsa, null, me.visualizzaScalaValutazioneDoloreSuccess, me.visualizzaScalaValutazioneDoloreError);
        },
        visualizzaScalaValutazioneDoloreSuccess(response) {
            let me = this;
            me.jsonDataValutazioneDolore = response.data.data;
        },
        visualizzaScalaValutazioneDoloreError(error) {
            console.log(error);
        },
    },
};
</script>
